import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"
import _imports_0 from '@/assets/loading.svg'


const _hoisted_1 = ["onSubmit"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "title-4 text-center" }, "Detail des interventions", -1)
const _hoisted_3 = {
  key: 0,
  class: "errors"
}
const _hoisted_4 = { class: "form-content mt-1" }
const _hoisted_5 = { class: "form-fields" }
const _hoisted_6 = { class: "field-header" }
const _hoisted_7 = ["for"]
const _hoisted_8 = ["name", "id", "onUpdate:modelValue"]
const _hoisted_9 = ["value"]
const _hoisted_10 = {
  class: "btn btn-primary mt-1",
  type: "submit"
}
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Télécharger ")
const _hoisted_12 = {
  key: 1,
  class: "spinner"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "spinner-icon",
  alt: "Spinner"
}, null, -1)
const _hoisted_14 = [
  _hoisted_13
]

import { request } from "@/domains/api/api";
import { useLoading } from "@/domains/app/loading";
import { useUser } from "@/domains/auth/user";
import { reactive, ref } from "vue";
import { downloadBlob } from "../../exports/exports";
import { getParsedFilters, useFilters } from "../filters";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { user } = useUser();

const { loading, setLoading } = useLoading("export.excel");
const error = ref<string | null>(null);

const selectedGroups = reactive<(string | null)[]>([null, null, null]);
const groups = {
    user_id: "Conducteur",
    department_id: "Département",
    game_id: "Gibier",
} as const;
const getAllowedGroups = (i: number): (null | keyof typeof groups)[] =>
    (Object.keys(groups) as (null | keyof typeof groups)[])
        .filter((g) => g === selectedGroups[i] || !selectedGroups.includes(g))
        .concat([null]);

const filters = useFilters().filters;

function downloadExcel() {
    error.value = null;
    if (!user.value || loading.value) return;
    if (selectedGroups.every((g) => g === null))
        return (error.value = "Veuillez sélectionner au moins un groupement");
    setLoading(true);

    request<string>(
        "exports/grouped-sheets",
        "get",
        () => (error.value = "Une erreur est survenue"),
        {
            group_by: selectedGroups.filter((v) => v !== null),
            ...getParsedFilters(filters.value),
        },
        { responseType: "blob" }
    )
        .then((rs) => {
            if (!rs) return (error.value = "Aucune fiche trouvée");
            downloadBlob(rs, "export.xlsx");
        })
        .catch(() => {
            error.value = "Une erreur est survenue";
        })
        .finally(() => setLoading(false));
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    class: "form",
    action: "",
    onSubmit: _withModifiers(downloadExcel, ["prevent"])
  }, [
    _hoisted_2,
    (error.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("p", null, _toDisplayString(error.value), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (i) => {
          return _createElementVNode("div", {
            class: "field form-row",
            key: i
          }, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("label", {
                for: 'group-' + i
              }, "Groupe " + _toDisplayString(i), 9, _hoisted_7)
            ]),
            _withDirectives(_createElementVNode("select", {
              name: 'group-' + i,
              id: 'group-' + i,
              class: "field__widget",
              "onUpdate:modelValue": ($event: any) => ((_unref(selectedGroups)[i - 1]) = $event)
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getAllowedGroups(i - 1), (group) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: group,
                  key: group ?? 'none'
                }, _toDisplayString(group ? _unref(groups)[group] : ""), 9, _hoisted_9))
              }), 128))
            ], 8, _hoisted_8), [
              [_vModelSelect, _unref(selectedGroups)[i - 1]]
            ])
          ])
        }), 64))
      ])
    ]),
    _createElementVNode("button", _hoisted_10, [
      (!_unref(loading))
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _hoisted_11
          ], 64))
        : (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_14))
    ])
  ], 40, _hoisted_1))
}
}

})